export const removeModalityEtc = (text: string): string => {
  return text.replace("(etc)", "");
};
